import BaseProxy from "../../base-proxy";

//#region Private Methods

//#endregion

/**
 * @class PutCompanyUserKycMessageOpened
 * @description Class used for communicating with company user's kyc message flag.
 * @author Gabriel Ocampo
 * @version 1.0
 * @since April 2, 2020
 */
export default class PutCompanyUserKycMessageOpened {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   * @param {String} input.companyUserId - Id of companyUser.
   * @param {Boolean} input.kycMessageOpened - If kyc message has been opened.
   */
  async toggleKycMessage(body = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/company-users/${body.companyUserId}/kyc-message-opened`;

    return await baseProxy.putAuthenticatedData(endpointUrl, body.authToken, body);
  }
}
